Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var _filterMethods = new Set();
_filterMethods.add('isMatch');
var _filters = new Map();
/**
 * Validates that the appender
 *
 * @private
 * @function
 *
 * @params {APPENDER} appender
 * @throws {Error} if the appender is invalid
 */
var _validateFilter = function (filter) {
    // if we are running ES6, we can make sure it extends LogAppender
    // otherwise, it must be a function
    if (!(filter instanceof __1.LogFilter)) {
        return;
    }
    // instantiate the appender function
    var filterObj = new filter();
    // ensure that the appender methods are present (and are functions)
    _filterMethods.forEach(function (element) {
        if (!filterObj[element] || !(filterObj[element] instanceof Function)) {
            throw new Error("Invalid filter: missing/invalid method: " + element);
        }
    });
};
exports.addFilter = function (filter, name) {
    _validateFilter(filter);
    // only put the appender into the set if it doesn't exist already
    if (!_filters.has(name)) {
        _filters.set(name, filter);
    }
    return filter;
};
exports.getFilter = function (name) { return _filters.get(name); };
